import * as Sentry from '@sentry/react';

import { APP_ENV } from './global/config/common.config';

const IS_PROD = APP_ENV === 'production';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: APP_ENV,
  release: '1',
  debug: !IS_PROD,
  enabled: true,

  initialScope: {
    tags: {
      react: 'true',
      vite: 'true',
      locale: typeof window !== 'undefined' ? window.navigator.language : 'unknown',
    },
  },

  tracesSampleRate: IS_PROD ? 0.1 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/dev-admin\.lfg.inc/, /^https:\/\/admin\.lfg.inc/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  maxBreadcrumbs: 50,
  normalizeDepth: 10,
  attachStacktrace: true,
  autoSessionTracking: true,
  ignoreErrors: ['ResizeObserver loop limit exceeded', 'Non-Error promise rejection captured'],

  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'xhr' && breadcrumb.data?.url) {
      try {
        const url = new URL(breadcrumb.data.url);
        breadcrumb.data.url = `${url.origin}${url.pathname}`;
      } catch {}
    }
    return breadcrumb;
  },

  beforeSend(event) {
    if (!event?.exception?.values?.[0]) return null;

    const firstError = event.exception.values[0];
    if (
      firstError.type === 'UnhandledRejection' &&
      firstError.value === 'Non-Error promise rejection captured with value: '
    ) {
      return null;
    }

    if (event.exception) {
      event.contexts = {
        ...event.contexts,
        browser: {
          name: navigator.userAgent,
          viewport: `${window.innerWidth}x${window.innerHeight}`,
        },
        runtime: {
          name: 'Node Sale Admin V3',
          version: 1,
        },
      };
    }

    return event;
  },

  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
});
